import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { STATUS } from "config/constants";
import { getCurationDateString } from "utils/contentDisplay";
import styles from "./CurationDate.css";

export default function CurationDate(props) {
  const dateString = getCurationDateString(props);

  return <div className={styles.root}>{dateString}</div>;
}

CurationDate.propTypes = {
  published_date: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  created_date: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  status: PropTypes.oneOf(Object.values(STATUS).map(x => x.slug)),
};
